'use client'

import { createContext } from 'react'

import type { AbSegment } from '@/types/nav-types'

export const AnalyticsContext = createContext<{
  segment: AbSegment
  distinctId?: string
  fontVariant?: 'inter' | 'system'
}>({
  segment: 'a',
  distinctId: undefined,
  fontVariant: 'inter',
})
